import { UseSearchOptions, defaultUseSearchOptions } from "./hooks/useSearch"
import { isWindowDefined } from "./window"

const ALIAS_LIST = {
  brandName: "watch.brand.name",
  modelName: "watch.model.name",
}

const DELETEABLE_URL_PARAMS = ["search", "itemsPerPage", "order"]

const generateSearchQuery = (query: string) => {
  if (query.includes("A. ")) {
    // filter out A. since it breaks search for some reason
    return query.replace("A. ", "")
  }

  return query
}

// TODO: check types
export const generateQueryParams = (
  query: string,
  options: UseSearchOptions
) => {
  const queryParams = new URLSearchParams()
  query !== "" && queryParams.append("search", generateSearchQuery(query) || "")
  queryParams.append(
    "itemsPerPage",
    options?.limit?.toString() || defaultUseSearchOptions.limit.toString()
  )
  queryParams.append(
    "page",
    options?.page?.toString() || defaultUseSearchOptions.page.toString()
  )

  if (options.filters) {
    Object.keys(options.filters).forEach((filterKey: string) => {
      const key = ALIAS_LIST[filterKey] || filterKey
      options.filters[filterKey].forEach((value: string) => {
        return value && value != "" && queryParams.append(`${key}[]`, value)
      })
    })
  }

  if (options.sorting && options.sorting !== "null") {
    const [sortKey, sortOrder] = options.sorting.split("_")
    queryParams.append(`order[${sortKey}]`, sortOrder)
  }

  return queryParams
}

export const generateUrlParams = (
  searchTerm: string,
  options: UseSearchOptions
) => {
  const urlParams = generateQueryParams(searchTerm, options)

  DELETEABLE_URL_PARAMS.forEach(element => urlParams.delete(element))
  urlParams.append("q", searchTerm)

  return urlParams
}

export const windowUrlParams = isWindowDefined
  ? new URLSearchParams(window.location.search)
  : null
